import React from "react"
import styled from "styled-components";

import { allData } from 'data/allData'

const ImageBox = styled.div`
display: flex;
justify-content: center;
padding: 10px;
`

const StartImage = styled.img`
width: 100%;
opacity: 40%;


`

const Home = ({url}) => {

  const story = allData;

  return(
    <ImageBox>
  
      <StartImage src={story[0].url} alt="Logo" />
    </ImageBox>
  )
}


export default Home
